import React from 'react';
import { NonEmbedAccessWizard } from './non-embed-access.wizard';

export const NonEmbedAccess: React.FC = () => {
    return <NonEmbedAccessWizard />;
};
export default NonEmbedAccess;
